import { FC } from "react";
import { useSelector } from "react-redux";

import { canSeeChat } from "../pages/Chat/utils";
import { ReduxState } from "../types/redux.types";
import { User } from "../types/user.types";
import Loader from "./Loader";
import { GetNotificationPermission } from "../shared/BaseNotificationList";
import { useCheckAgentType } from "../hooks/useCheckAgentType";

export const CheckCurrentUser: FC = ({ children }) => {
  const user = useSelector<ReduxState, User>((state) => state.user);
  const loadingUser = useSelector<ReduxState, boolean>((state) => state.user.loading);

  const agentType = useCheckAgentType();

  return (
    <Loader loading={loadingUser} height="100vh" size={40}>
      {children}
      {agentType.isWeb && user.id && canSeeChat(user.role) && <GetNotificationPermission />}
    </Loader>
  );
};

export default CheckCurrentUser;
